import { createRouter, createWebHashHistory } from "vue-router";
import authSession from "@/api/authSession";

const DefaultContainer = () => import("@/containers/DefaultContainer");
const ClearForm = () => import("@/containers/ClearForm");

const Profile = () => import("@/views/member/Profile");
const ProfileEdit = () => import("@/views/member/ProfileEdit");
const ProfileCharacterCreate = () =>
  import("@/views/member/ProfileCharacterCreate");
const Events = () => import("@/views/member/Events");
const Members = () => import("@/views/member/Members");

const AdminDashboard = () => import("@/views/admin/Dashboard");
const AdminRequests = () => import("@/views/admin/Requests");
const AdminMembers = () => import("@/views/admin/Members");
const AdminRegistration = () => import("@/views/admin/Registration");
const AdminStaff = () => import("@/views/admin/Staff");
const AdminNotifications = () => import("@/views/admin/Notifications");
const AdminMessages = () => import("@/views/admin/Messages");
const AdminItemsList = () => import("@/views/admin/items/ItemsList");
const AdminItemEdit = () => import("@/views/admin/items/ItemEdit");
const AdminFirmwaresList = () =>
  import("@/views/admin/firmwares/FirmwaresList");
const AdminFirmwareAdd = () => import("@/views/admin/firmwares/FirmwareAdd");
const AdminLocationsList = () =>
  import("@/views/admin/locations/LocationsList");
const AdminLocationEdit = () => import("@/views/admin/locations/LocationEdit");
const AdminQuestsList = () => import("@/views/admin/quests/QuestsList");

const Scan = () => import("@/views/Scan");
const Register = () => import("@/views/register/Register");
const Login = () => import("@/views/Login");
const PassRestore = () => import("@/views/PassRestore");
const PassChange = () => import("@/views/PassChange");

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/system",
      component: DefaultContainer,
      redirect: { name: "Profile" },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: AdminDashboard
        },
        {
          path: "",
          name: "Profile",
          component: Profile
        },
        {
          path: "edit/:id",
          name: "ProfileEdit",
          component: ProfileEdit
        },
        {
          path: "create",
          name: "ProfileCreate",
          component: ProfileCharacterCreate
        },
        {
          path: "events",
          name: "Events",
          component: Events
        },
        {
          path: "event/:id/members",
          name: "EventMembers",
          component: Members
        },
        {
          path: "admin/requests",
          name: "AdminRequests",
          component: AdminRequests
        },
        {
          path: "admin/members",
          name: "AdminMembers",
          component: AdminMembers
        },
        {
          path: "admin/register",
          name: "AdminRegistration",
          component: AdminRegistration
        },
        {
          path: "admin/staff",
          name: "AdminStaff",
          component: AdminStaff
        },
        {
          path: "admin/notifications",
          name: "AdminNotifications",
          component: AdminNotifications
        },
        {
          path: "admin/messages",
          name: "AdminMessages",
          component: AdminMessages
        },
        {
          path: "admin/items",
          name: "AdminItems",
          component: AdminItemsList
        },
        {
          path: "admin/items/edit/:id",
          name: "AdminItemEdit",
          component: AdminItemEdit
        },
        {
          path: "admin/firmwares",
          name: "AdminFirmwares",
          component: AdminFirmwaresList
        },
        {
          path: "admin/firmwares/edit/:id",
          name: "AdminFirmwareAdd",
          component: AdminFirmwareAdd
        },
        {
          path: "admin/locations",
          name: "AdminLocations",
          component: AdminLocationsList
        },
        {
          path: "admin/locations/edit/:id",
          name: "AdminLocationEdit",
          component: AdminLocationEdit
        },
        {
          path: "admin/quests",
          name: "AdminQuests",
          component: AdminQuestsList
        }
      ]
    },
    {
      path: "/",
      redirect: { name: "Login" },
      component: ClearForm,
      children: [
        {
          path: "scan",
          name: "Scan",
          component: Scan
        },
        {
          path: "register",
          name: "Register",
          component: Register
        },
        {
          path: "login",
          name: "Login",
          component: Login
        },
        {
          path: "restore",
          name: "Restore",
          component: PassRestore
        },
        {
          path: "restore/:uuid/:token",
          name: "PassChange",
          component: PassChange
        }
      ]
    }
  ]
});

export const publicRoutes = new Set([
  "Login",
  "Register",
  "Restore",
  "PassChange",
  "Scan"
]);

export function authGuard(to) {
  if (publicRoutes.has(to.name)) {
    return true;
  }

  if (!authSession.isAuthenticated()) {
    return { name: "Login" };
  }

  return true;
}

router.beforeEach(authGuard);

export default router;
